export default __webpack_public_path__ + "static/media/my-banner.18c256fd.png";